/*eslint camelcase: ["error", {properties: "never"}]*/
import React from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { formatDate4 } from '../../../utils/dateFormat';
import { ASKTED_TTEC_DASHBOARD_URI } from '../../../constants';
import './CoachingInsightCallDetailsTable.scss';

interface insightCallDetailsProps {
    callDetails: any;
}
export const CoachingInsightCallDetailsTable = ({ callDetails }: insightCallDetailsProps) => {
    const callIdTemplate = (rowData: any) => {
        const callId = rowData?.call_id;
        const date= new Date(rowData?.date);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return (
            <a
                // href={`${LOOKER_DASHBOARD_URI}?Date+-+TZ+%3A%3A+America%2FDenver=${year}-${month}&Call+Id=${callId}`}
                href={`${ASKTED_TTEC_DASHBOARD_URI}?Date+-+TZ+%3A%3A+America%2FDenver=${year}-${month}&Call+Id=${callId}`}
                target="_blank"
                rel="noopener noreferrer"
            >
                <span className="image-text">{callId}</span>
            </a>
        );
    };
    const dateBodyTemplate = (rowData: any) => {
        return formatDate4(rowData.date);
    };
    return (
        <div className="row" style={{ width: '100%' }}>
            <DataTable
                style={{ width: '100%' }}
                id='coaching-summary'
                className='callDetailTable'
                value={callDetails?.data?.length > 0 ? callDetails?.data : []}
                rows={5}
                paginator={callDetails?.data?.length > 5}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 25, 50]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                emptyMessage="No records found."
            >
                <Column header="Call Id" field="call_id" 
                    style={{ width:'150px'}}
                    body={callIdTemplate}
                    sortable />
                <Column
                    header="Date"
                    sortable
                    sortField='date'
                    body={dateBodyTemplate} 
                />
            </DataTable>
        </div>
    );
};
